import type { ExtensionManifest, ExtensionSettingsValues } from './types';

export interface UserExtensionRow {
  extension_id: string;
  enabled: boolean;
  settings: Record<string, unknown> | null;
}

/** A missing row means the user never touched it: fall back to the manifest. */
export function isExtensionEnabled(manifest: ExtensionManifest, row?: UserExtensionRow | null): boolean {
  return row ? row.enabled : manifest.defaultEnabled;
}

/**
 * Manifest defaults overlaid with the user's stored values. Stored values of
 * the wrong type, or for fields that no longer exist, are dropped.
 */
export function resolveSettings(
  manifest: ExtensionManifest,
  stored?: Record<string, unknown> | null,
): ExtensionSettingsValues {
  const values: ExtensionSettingsValues = {};
  for (const [key, field] of Object.entries(manifest.settings)) {
    const raw = stored?.[key];
    if (field.type === 'number') {
      const n = typeof raw === 'number' ? raw : typeof raw === 'string' ? parseFloat(raw) : NaN;
      const inRange =
        Number.isFinite(n) &&
        (field.min === undefined || n >= field.min) &&
        (field.max === undefined || n <= field.max);
      values[key] = inRange ? n : field.default;
    } else if (field.type === 'select') {
      const s = raw === undefined || raw === null ? '' : String(raw);
      values[key] = field.options.some((o) => o.value === s) ? s : field.default;
    } else {
      values[key] = typeof raw === 'string' ? raw : field.default;
    }
  }
  return values;
}
